import React from "react";
import { siteInfo } from "../data/siteData";
import rmc from '../assets/images/rmc.png';
import Slider from "../components/Slider";


const RMC = () => {
  return (
    <>
      <style>{`
        :root{
          --primary:#f97316;
          --dark:#1f2937;
          --light:#f3f4f6;
          --text:#6b7280;
        }

        .rmc-wrapper{
          font-family: Arial, sans-serif;
          background: #fff;
        }

        /* HERO */
        .rmc-hero{
          background:url("/images/rmc-banner.jpg") center/cover no-repeat;
          height:300px;
          position:relative;
          display:flex;
          align-items:center;
          justify-content:center;
          color:#fff;
        }

        .rmc-hero::after{
          content:"";
          position:absolute;
          inset:0;
          background:rgba(0,0,0,0.6);
        }

        .rmc-hero-content{
          position:relative;
          text-align:center;
          z-index:2;
        }

        .rmc-hero h1{
          font-size:36px;
          margin-bottom:10px;
        }

        .breadcrumb{
          color:var(--primary);
          font-size:14px;
        }

        /* SECTION COMMON */
        .section{
          padding:80px 20px;
        }

        .container{
          max-width:1200px;
          margin:auto;
        }

        .section-title{
          text-align:center;
          margin-bottom:50px;
        }

        .section-title h2{
          font-size:28px;
          color:var(--dark);
        }

        .section-title span{
          color:var(--primary);
          font-weight:600;
          text-transform:uppercase;
          font-size:13px;
        }

        /* ABOUT */
        .about-grid{
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:50px;
          align-items:center;
        }

        .about-grid img{
          width:100%;
          border-radius:10px;
        }

        .about-text h3{
          font-size:24px;
          color:var(--dark);
          margin-bottom:15px;
        }

        .about-text p{
          color:var(--text);
          line-height:1.7;
        }

        /* BENEFITS */
        .benefits{
          background:var(--light);
        }

        .benefit-card{
          background:#fff;
          padding:20px 25px;
          margin-bottom:15px;
          border-radius:8px;
          box-shadow:0 4px 15px rgba(0,0,0,0.05);
          border-left:4px solid var(--primary);
        }

        .benefit-card h4{
          margin-bottom:8px;
          color:var(--dark);
        }

        .benefit-card p{
          color:var(--text);
          font-size:14px;
        }

        /* CTA */
        .cta{
          background:var(--primary);
          color:#fff;
          text-align:center;
          padding:60px 20px;
        }

        .cta h2{
          margin-bottom:20px;
        }

        .cta button{
          background:#fff;
          color:var(--primary);
          padding:12px 25px;
          border:none;
          border-radius:5px;
          font-weight:600;
          cursor:pointer;
        }

        @media(max-width:768px){
          .about-grid{
            grid-template-columns:1fr;
          }
        }
      `}</style>

      <div className="rmc-wrapper">

        {/* HERO */}
      <Slider/>

        {/* ABOUT SECTION */}
        <section className="section">
          <div className="container about-grid">
           <img 
                src={rmc} 
                alt="About Glazerocks RMC" 
                className="img-fluid my-auto" 
              />
            <div className="about-text">
              <span style={{color:"#f97316",fontWeight:"600"}}>14 Years Experience</span>
              <h3>We Are The Leader In Ready Mix Concrete Manufacturing</h3>
              <p>
                {siteInfo.name} has been delivering high-quality Ready Mix Concrete
                solutions for over 14 years. With advanced batching plants and
                modern transit mixers, we ensure consistent quality, strength,
                and on-time delivery for residential, commercial, and
                infrastructure projects.
              </p>
            </div>
          </div>
        </section>

        {/* BENEFITS */}
        <section className="section benefits">
          <div className="container">
            <div className="section-title">
              <span>RMC Benefits</span>
              <h2>Benefits Of Ready Mixed Concrete Over Site Mixed Concrete</h2>
            </div>

            <div className="benefit-card">
              <h4>Cost-Effectiveness</h4>
              <p>Ready mixed concrete is more cost-effective because: materials are not stored onsite, reducing the need for space; plant/machinery for mixing is not required; wastage of materials is avoided; labor needs are reduced; and the overall production process is faster.</p>
            </div>

            <div className="benefit-card">
              <h4>Diversity of Solutions</h4>
              <p>A wide variety of ready mixed concrete can be produced on-demand by varying the ratios of cement, aggregates, and admixtures to meet specific construction needs.</p>
            </div>

            <div className="benefit-card">
              <h4>Customer Service</h4>
              <p>RMC ensures excellent customer service through flexible delivery scheduling, availability of multiple mixer trucks, and support for complex worksites via pumps, conveyors, and other tools.</p>
            </div>

            <div className="benefit-card">
              <h4>Quality</h4>
              <p>Produced in automated batching plants, RMC ensures superior and consistent quality by using well-controlled raw materials and strict quality checks throughout production and delivery.</p>
            </div>

            <div className="benefit-card">
              <h4>Lower Pollution</h4>
              <p>Since mixing occurs at a centralized plant, RMC significantly reduces air and noise pollution at construction sites.</p>
            </div>

            <div className="benefit-card">
              <h4>Inventory Control</h4>
              <p>With RMC, material usage is optimized and monitored, enabling better inventory control and minimizing resource wastage.</p>
            </div>

          </div>
        </section>

        {/* CTA */}
      

      </div>
    </>
  );
};

export default RMC;